import React, { useState, useEffect } from "react";
import axios from "axios";
import { Button, message, Input, Form } from "antd/lib";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
function PospForgetPassword({ setShowPassword }) {
  const [form] = Form.useForm();
  const RemPass = useSelector((state) => state?.pass);
  const [LogDetail, setLogDetail] = useState(RemPass);
  const [email, setemail] = useState("");
  const [iserror, setiserror] = useState(false);
  const [loading, setloading] = useState(false);
  const [rememberPassword, setRememberPassword] = useState(false);
  const [BaseUrl, setBaseURL] = useState(process.env.REACT_APP_UAT_BASE_URL);

  useEffect(() => {
    setRememberPassword(true);
    setemail(LogDetail?.rememberedEmail);
    form.setFieldsValue({
      email: LogDetail?.rememberedEmail,
    });
  }, [LogDetail, BaseUrl]);

  const handleSubmit = () => {
    if (email) {
      setiserror(false);
      setloading(true);
      axios
        .post(`${BaseUrl}v1/posp/forgot-password`, {
          email: email,
        })
        .then((res) => {
          console.log(res);
          setloading(false);
          message.success("We have emailed your password reset link!");
          setShowPassword(false);
        })
        .catch((err) => {
          console.log(err);
          setloading(false);
        });
    } else {
      setiserror(true);
    }
  };
  return (
    <div className="logn-body-rn">
      <div className="login-cont-r">
        <div className="login-inpt-div">
          <div className="d-block text-center my-2 forget-txt">
            <h4 className="mb-2">
              Enter the email address associated with your Account and we'll
              send you a link to reset your password.
            </h4>
          </div>
          <div className="inpt-number-din-r">
            <div className="mb-2">
              <Form
                onFinish={handleSubmit}
                form={form}
                requiredMark={false}
                layout="vertical"
              >
                <Form.Item
                  name="email"
                  label="Email"
                  rules={[
                    {
                      required: true,
                      message: "Please Enter Email",
                    },
                  ]}
                >
                  <Input
                    size="large"
                    // prefix={<UserOutlined />}
                    onChange={(e) => {
                      setemail(e.target.value);
                    }}
                    placeholder="Enter Email"
                  />
                </Form.Item>
                <Form.Item>
                  <Button
                    type="primary"
                    htmlType="submit"
                    style={{
                      width: "100%",
                      background: "#293890",
                      border: "#293890",
                      marginTop: "3%",
                      maxHeight: "42px",
                      minHeight: "42px",
                    }}
                    loading={loading}
                  >
                    Send Password Reset Link
                  </Button>
                </Form.Item>
              </Form>
            </div>
            <div className="d-flex justify-content-center gap-2">
              <p>Don't Have Account?</p>
              <Link
                to={{
                  pathname: "/OtpLogin",
                }}
                // target="_blank"
              >
                SignUp
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export { PospForgetPassword };
